const SHARE_CONFIG = {
  facebook: {
    name: 'Facebook',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>',
    color: '#1877F2',
    getUrl: (url, text) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&t=${encodeURIComponent(text)}`
  },
  x: {
    name: 'X (Twitter)',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
    color: '#000000',
    getUrl: (url, text) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`
  },
  whatsapp: {
    name: 'WhatsApp',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.4601 3.49197C19.3599 2.38068 18.0495 1.49958 16.6053 0.900037C15.161 0.300495 13.6119 -0.00546804 12.0481 -2.00585e-05C5.49616 -2.00585e-05 0.15618 5.33996 0.15618 11.8919C0.15618 13.9919 0.708179 16.0319 1.74018 17.8319L0.0601807 23.9999L6.36016 22.3439C8.10016 23.2919 10.0561 23.7959 12.0481 23.7959C18.6001 23.7959 23.9402 18.4559 23.9402 11.9039C23.9402 8.72395 22.7041 5.73596 20.4601 3.49197ZM12.0481 21.7799C10.2721 21.7799 8.53216 21.2999 7.00816 20.3999L6.64816 20.1839L2.90417 21.1679L3.90017 17.5199L3.66017 17.1479C2.67347 15.5723 2.14954 13.751 2.14817 11.8919C2.14817 6.44396 6.58816 2.00397 12.0361 2.00397C14.6761 2.00397 17.1601 3.03597 19.0201 4.90797C19.9411 5.82472 20.6709 6.91515 21.1673 8.11606C21.6638 9.31698 21.917 10.6045 21.9121 11.9039C21.9361 17.3519 17.4961 21.7799 12.0481 21.7799ZM17.4721 14.3879C17.1721 14.2439 15.7081 13.5239 15.4441 13.4159C15.1681 13.3199 14.9761 13.2719 14.7721 13.5599C14.5681 13.8599 14.0041 14.5319 13.8361 14.7239C13.6681 14.9279 13.4881 14.9519 13.1881 14.7959C12.8881 14.6519 11.9281 14.3279 10.8001 13.3199C9.91209 12.5279 9.32415 11.5559 9.14415 11.2559C8.97616 10.9559 9.12015 10.7999 9.27615 10.6439C9.40815 10.5119 9.57615 10.2959 9.72009 10.1279C9.86409 9.95995 9.92409 9.82795 10.0201 9.63595C10.1161 9.43195 10.0681 9.26395 9.99609 9.11995C9.92409 8.97595 9.32415 7.51196 9.08416 6.91196C8.84416 6.33596 8.59216 6.40796 8.41216 6.39596H7.83616C7.63216 6.39596 7.32016 6.46796 7.04416 6.76796C6.78016 7.06796 6.01216 7.78796 6.01216 9.25195C6.01216 10.7159 7.08016 12.1319 7.22416 12.3239C7.36816 12.5279 9.32415 15.5279 12.3001 16.8119C13.0081 17.1239 13.5601 17.3039 13.9921 17.4359C14.7001 17.6639 15.3481 17.6279 15.8641 17.5559C16.4401 17.4719 17.6281 16.8359 17.8681 16.1399C18.1201 15.4439 18.1201 14.8559 18.0361 14.7239C17.9521 14.5919 17.7721 14.5319 17.4721 14.3879Z" fill="currentColor"/>
      </svg>
    `,
    color: '#25D366',
    getUrl: (url, text) => `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`
  }
};

const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy text:', err);
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      const success = document.execCommand('copy');
      document.body.removeChild(textarea);
      return success;
    } catch (e) {
      return false;
    }
  }
};

export const getShareLinks = (title, url = window.location.href) => {
  const encodedUrl = encodeURIComponent(url);
  const shareText = encodeURIComponent(title);

  return {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&t=${shareText}`,
    x: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${shareText}`,  // Changed from 'twitter' to 'x'
    whatsapp: `https://wa.me/?text=${shareText}%20${encodedUrl}`
  };
};

export const shareComponent = async (componentName, url = window.location.href) => {
  const shareTitle = `Kerala Panchayat Elections 2025 - ${componentName}`;
  const shareText = `Check out the ${componentName} results for Kerala Panchayat Elections 2025`;
  const shareLinks = getShareLinks(shareTitle, url);

  try {
    if (navigator.share) {
      await navigator.share({
        title: shareTitle,
        text: shareText,
        url: url,
      });
      return { showModal: false };
    }
    return { showModal: true, shareLinks, shareText, url };
  } catch (err) {
    if (err.name !== 'AbortError') {
      console.error('Error sharing:', err);
      return { showModal: true, shareLinks, shareText, url };
    }
    return { showModal: false };
  }
};

// React component to render the share modal
export const ShareModal = ({ isOpen, onClose, shareLinks, shareText, url }) => {
  if (!isOpen) return null;

  const handleSocialShare = (e, url) => {
    e.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');
    onClose();
  };

  const handleCopyLink = async (e) => {
    e.preventDefault();
    if (await copyToClipboard(url)) {
      alert('Link copied to clipboard!');
      onClose();
    }
  };

  return (
    <div
      className="share-modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <div
        className="share-modal"
        onClick={e => e.stopPropagation()}
        style={{
          background: 'white',
          padding: '24px',
          borderRadius: '8px',
          width: '90%',
          maxWidth: '380px',
          position: 'relative',
          textAlign: 'center',
        }}
      >
        <h3 style={{ margin: '0 0 20px 0', color: '#333' }}>Share via</h3>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '20px' }}>
          {Object.entries(shareLinks).map(([key, url]) => (
            <a
              key={key}
              href={url}
              onClick={(e) => handleSocialShare(e, url)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                color: SHARE_CONFIG[key].color,
                textDecoration: 'none',
              }}
              title={`Share on ${SHARE_CONFIG[key].name}`}
              target="_blank"
              rel="noopener noreferrer"
              dangerouslySetInnerHTML={{ __html: SHARE_CONFIG[key].icon }}
            />
          ))}
          <button
            onClick={handleCopyLink}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#4CAF50',
            }}
            title="Copy link"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
            </svg>
          </button>
        </div>
        <button
          onClick={onClose}
          style={{
            padding: '8px 16px',
            background: '#f0f0f0',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};